export interface StopPropagationEventType {
  stopPropagation: () => void;
}

export const eventStopPropagation = (event: StopPropagationEventType) => {
  event.stopPropagation();
};

interface PreventDefaultEventType {
  preventDefault: () => void;
}

export const eventPreventDefault = (event: PreventDefaultEventType) => {
  event.preventDefault();
};
